import { render, staticRenderFns } from "./PlaceHolderTableBody.vue?vue&type=template&id=65231fe6&scoped=true&"
import script from "./PlaceHolderTableBody.vue?vue&type=script&lang=js&"
export * from "./PlaceHolderTableBody.vue?vue&type=script&lang=js&"
import style0 from "./PlaceHolderTableBody.vue?vue&type=style&index=0&id=65231fe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65231fe6",
  null
  
)

export default component.exports